import React, { useState, useEffect } from 'react';
import LearningPathLayout from './LearningPathLayout';
import { 
  getLearningPathForLearner,
} from '../../../Services/LearningPathService';
import './LearningPathViewer.scss';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import {i18n} from "../../../Utils/i18n/i18n";
import {SignDocUploadStatus} from '../../SignDoc/SignDocLib';

/**
 * LearningPathViewer component that displays a learning path to a learner
 * Handles data loading, error states, and item interaction
 */
const LearningPathViewer = ({ signDocId }) => {
  const [loading, setLoading] = useState(true);
  const [rootSignDoc, setRootSignDoc] = useState();
  const [pathItems, setPathItems] = useState([]);

  const init = async () => {
    try {
      setLoading(true);
      // Fetch data using the updated service
      const { items, error } = await getLearningPathForLearner(signDocId);
      if (error) {
        setPathItems([]);
      } else {
        // Set items
        let filteredItems = items.filter(item => !item.isRoot && item.signDoc.uploadStatus !== SignDocUploadStatus.FAILED);
        setPathItems(filteredItems);

        // Store the backend progress for later comparison
        const rootItem = items.find(item => item.isRoot);
        setRootSignDoc(rootItem);
      }
    } catch (err) {
      console.error('Error loading learning path:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch learning path data
  useEffect(() => {
    init();
  }, [signDocId]);

  
  // Loading state
  if (loading) {
    return (
      <div className="learning-path-viewer loading">
          <LoadingSpinner />
      </div>
    );
  } else if (!pathItems || pathItems.length === 0) {
    return (
            <div className="noSignDocs">{i18n.translate('LearningPath.noLearningPathItems')}</div>
          )
  }

  // Normal state with content
  return (
    <div className="learning-path-viewer" style={{ width: '100%', maxWidth: '100%' }}>
        <LearningPathLayout
          items={pathItems}
          rootSignDoc={rootSignDoc}
        />
    </div>
  );
};

export default LearningPathViewer; 